// Lib
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Utils
import { isFeedbackOnlyAccess, isFullAccess, isReadOnly } from '../../../../common/permissions/permissionUtil';
import { buildAppRegisterOverlayUrl } from '../../../auth/modals/register/registrationUtils';

// Actions
import { navigateToUrl } from '../../../reducers/navigationActions';

// Selectors
import { getLocationQuery, getUrlPermissionId } from '../../../app/routingSelector';
import { selectBoardPermissionToastPermissions } from './boardPermissionToastSelector';
import { getCurrentBoardId } from '../../../reducers/currentBoardId/currentBoardIdSelector';

// Components
import Toast from '../../../structural/toast/Toast';
import LoadableAppRegister from '../../../auth/modals/register/LoadableAppRegister';
import GuestFullBoardPermissionToast from './GuestFullBoardPermissionToast';
import Icon from '../../../components/icons/Icon';

// Constants
import { REGISTRATION_ENTRY_POINT } from '../../../../common/users/userConstants';
import { PUBLISH_FEEDBACK_REGISTRATION_ONBOARDING } from '../../../../common/users/userEducationConstants';

// Styles
import './GuestBoardPermissionToast.scss';

const GuestBoardPermissionToast: React.FC = () => {
    const currentBoardId = useSelector(getCurrentBoardId);
    const permissions = useSelector(selectBoardPermissionToastPermissions);
    const urlPermissionId = useSelector(getUrlPermissionId);
    const locationQuery = useSelector(getLocationQuery);

    // TODO Remove BoardWriteStatusUtil
    useEffect(() => {
        LoadableAppRegister.preload();
    }, []);

    const dispatch = useDispatch();

    if (isFullAccess(permissions)) {
        return (
            <GuestFullBoardPermissionToast
                currentBoardId={currentBoardId}
                urlPermissionId={urlPermissionId}
                locationQuery={locationQuery}
            />
        );
    }

    const appRegisterUrl = buildAppRegisterOverlayUrl({
        currentBoardId,
        permissionId: urlPermissionId,
        locationQuery,
        registrationEntryPoint: REGISTRATION_ENTRY_POINT.PUBLISHED_REGISTRATION,
        onboarding: PUBLISH_FEEDBACK_REGISTRATION_ONBOARDING,
    });

    const navigateToRegister = useCallback(() => {
        dispatch(navigateToUrl(appRegisterUrl));
    }, [appRegisterUrl]);

    if (isFeedbackOnlyAccess(permissions)) {
        return (
            <Toast className="BoardPermissionToast GuestBoardPermissionToast feedback" onClick={navigateToRegister}>
                <Icon name="board-status-feedback" />
                <span>Add a comment</span>
            </Toast>
        );
    }

    if (isReadOnly(permissions)) {
        return (
            <Toast className="BoardPermissionToast GuestBoardPermissionToast read-only" onClick={navigateToRegister}>
                <Icon name="board-status-read-only" />
                <span>Read only</span>
            </Toast>
        );
    }

    return null;
};

export default GuestBoardPermissionToast;
